module.exports = __webpack_public_path__ + "img/dansk.878dc5be.svg";